import React, { useState, useEffect } from "react";
import Pagination from "../shared/pagination";

import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { getSlideBets } from "../originals/originals-games-api";
import { format } from "../shared/utils/dates";
import { Table, Tbody, Td, Th, Thead, Tr } from "react-super-responsive-table";

const UserSlideBets = () => {
  const [data, setData] = useState({ total_pages: 0, bets: [] });
  const [isLoading, setIsLoading] = useState(false);

  const [page, setPage] = useState(1);

  const { id } = useParams();

  const fetch = async () => {
    setIsLoading(true);
    try {
      const data = await getSlideBets(id, { page });
      setData({ total_pages: data.total_pages, bets: data.records });
    } catch (err) {
      toast.error(err.message);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  return (
    <div style={{ position: "relative", minHeight: 500 }}>
      {isLoading && (
        <div className={"loading-overlay"}>
          <h2>Loading, please wait ...</h2>
          <div className="loader" />
        </div>
      )}

      <Table>
        <Thead>
          <Tr>
            <Th>Bet ID</Th>
            <Th>Game Started At</Th>
            <Th>Amount</Th>
            <Th>Target</Th>
            <Th>Free bet</Th>
            <Th>Winnings</Th>
            <Th>Slide Point</Th>
            <Th>Status</Th>
            <Th>Profit</Th>
          </Tr>
        </Thead>

        <Tbody>
          {data.bets.map((b, i) => {
            const {
              remote_round_id,
              created_at,
              remote_bet_id,
              multiplier = 0,
              free_bet,
            } = b;
            const { slide_point, status, target, currency_type, amount } = b;
            const winnings =
              +multiplier > 0
                ? parseFloat(+amount * +multiplier).toFixed(4)
                : -amount;
            const profit = winnings > 0 ? winnings - amount : winnings;
            return (
              <Tr key={i}>
                <Td>
                  <Link to={`/casino/game-provider-rounds/${remote_round_id}`}>
                    {remote_bet_id}
                  </Link>
                </Td>
                <Td>{format.withSeconds(created_at)}</Td>
                <Td>
                  {amount} {currency_type}
                </Td>
                <Td>{target}</Td>
                <Td>{free_bet ? "yes" : "no"}</Td>
                <Td className={profit >= 0 ? "good" : ""}>
                  {winnings > 0 ? `${winnings} ${currency_type}` : "-"}
                </Td>
                <Td>{slide_point}</Td>
                <Td>{status}</Td>
                <Td className={winnings >= 0 ? "good" : "bad"}>
                  {parseFloat(profit).toFixed(4)} {currency_type}
                </Td>
              </Tr>
            );
          })}
        </Tbody>
      </Table>

      <Pagination
        total_pages={data.total_pages}
        update={(page) => setPage(page)}
      />
    </div>
  );
};
export default UserSlideBets;
